import i18n from '@yandex-int/i18n';
import * as keyset from 'i18n/DraftControlPanel';

import { BaseTooltipAction, TooltipState } from '../types';

const t = i18n(keyset);

type DonationSettingsTooltipAction = BaseTooltipAction;

interface GetBaseTooltipReducerParams {
    successLabel: string;
}

export const getBaseTooltipReducer =
    ({ successLabel }: GetBaseTooltipReducerParams) =>
    (state: TooltipState, action: DonationSettingsTooltipAction): TooltipState => {
        switch (action) {
            case 'error':
                return {
                    tooltipVisible: true,
                    tooltipTheme: 'error',
                    tooltipLabel: t('error'),
                };
            case 'ok':
                return {
                    tooltipVisible: true,
                    tooltipTheme: 'normal',
                    tooltipLabel: successLabel,
                };
            case 'clear':
                return {
                    tooltipVisible: false,
                };
        }
    };
